import React from "react";
import { motion } from "framer-motion";

const MissionHero = () => {
  return (
    <div className="relative">
      <section className="relative h-[70vh] flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ 
            backgroundImage: 'url("/lovable-uploads/ee84d10e-e2b5-4b28-9e36-17737dc1814b.png")',
          }}
        >
          <div className="absolute inset-0 bg-black/40" />
        </div>
        
        <div className="relative container mx-auto px-4 text-center text-white">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 drop-shadow-lg">Our Mission</h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto drop-shadow-md">
            To safeguard our crops from viral threats, enhance the quality and yield of our produce, 
            and expand our market reach worldwide.
          </p>
        </div>
      </section>
    </div>
  );
};

export default MissionHero;